// Polyfills are placed here to get imported before any bootstrapping code runs
//
// NOTE: NEVER add a polyfill that is not part of a spec implemented at least in all the modern browsers (Edge, Chrome, Firefox)

import 'core-js/es6/symbol';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/object/entries';
import 'core-js/fn/object/values';
import 'raf/polyfill';
import './array.prototype.includes';
import './number.isInteger';
import './string.prototype.codePointAt';
import 'whatwg-fetch';
